<template>
    <section class="legal-section">
        <div class="container">
            <h1 class="legal-title">Cookie Policy</h1>
            <p class="legal-intro">
                This Cookie Policy explains how HarashFit ("we", "our", or "us") uses cookies and similar technologies
                on our website (harashfit.com) to improve user experience, personalize content, and analyze website
                traffic. We are committed to transparency in how we use such technologies and the choices you have.
            </p>

            <h2>What Are Cookies?</h2>
            <p>
                Cookies are small text files stored on your device when you visit a website. They help websites remember
                your preferences and actions over time, allowing for a more customized and efficient browsing
                experience.
            </p>

            <h2>Types of Cookies We Use</h2>
            <ul>
                <li><strong>Strictly Necessary Cookies:</strong> Essential for the basic functionality of our website,
                    such as navigation, login, and saving language or privacy preferences.</li>
                <li><strong>Performance Cookies:</strong> Help us understand how visitors use the website by collecting
                    data anonymously (e.g., pages visited, error reports).</li>
                <li><strong>Functional Cookies:</strong> Allow us to remember your settings and preferences for a more
                    personalized experience.</li>
                <li><strong>Analytics & Marketing Cookies:</strong> Used by tools like <strong>Google Analytics</strong>
                    and <strong>Meta Pixel</strong> to collect visitor statistics and improve our marketing efforts.
                    These cookies are only used if you give us consent.</li>
            </ul>

            <h2>Your Consent</h2>
            <p>
                On your first visit to our website, you may see a cookie banner asking for your consent to use certain
                cookies. You can choose to accept or reject non-essential cookies. Your preferences can be changed at
                any time through your browser or device settings.
            </p>

            <h2>Managing Cookies</h2>
            <p>
                Most web browsers allow you to control cookies through their settings. You can delete existing cookies
                or configure your browser to block future ones. However, disabling some cookies may affect your ability
                to use certain features of the site.
            </p>

            <h2>Updates to This Policy</h2>
            <p>
                We may update this Cookie Policy from time to time to reflect changes in technology, legal requirements,
                or our practices. Any updates will be posted on this page with an updated effective date.
            </p>

            <h2>Contact Us</h2>
            <p class="legal-footer">
                If you have any questions or concerns about our use of cookies, feel free to contact us:<br />
                <strong>Email:</strong> info@harashfit.com<br />
                <strong>Phone:</strong> +962 7 9060 6181<br />
                <strong>Address:</strong> Amman, Jordan
            </p>
        </div>
    </section>
</template>



<style scoped>
.legal-section {
    padding: 10px 20px;
    color: #f0f0f0;
    min-height: 100vh;
    line-height: 1.7;
    font-size: 15px;
}

.container {
    max-width: 900px;
    margin: auto;
}

.legal-title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #ffffff;
    text-align: center;
}

.legal-intro {
    font-size: 16px;
    margin-bottom: 30px;
    color: #dddddd;
}

h2 {
    margin-top: 32px;
    font-size: 22px;
    color: #ff5555;
}

ul {
    margin-left: 20px;
    margin-top: 10px;
    color: #cccccc;
}

li {
    margin-bottom: 12px;
}

.legal-footer {
    margin-top: 40px;
    font-size: 14px;
    color: #aaa;
}
</style>